<template>
  <span>{{accountLocationName}}</span>
</template>


<script>
export default {
  name: 'AccountLocationDisplay',
  props: {
    id: Number
  },
  computed: {
    accountLocationName() {
      var accLocation = this.$store.getters['account/getAccLocationById'](this.id)
      if(accLocation)
        return accLocation.name
      return '-'
    }
  }

}
</script>